<template>
  <div class="inspection-route-map-container">
    <div id="inspectionRouteMap" style="width: 100%; height: 600px;"></div>
  </div>
</template>

<script>
import { listInspectionRoutePoints } from '@/api/inspection/inspectionPointApi'
import { getCommunityId } from '@/api/community/communityApi'
import { loadTianditu } from '@/utils/tianditu'
import { storeToTianditu } from '@/utils/coordTransform'

export default {
  name: 'InspectionRouteMap',
  data() {
    return {
      map: null,
      communityId: '',
      routePoints: [],
      markers: [],
      labels: [],
      polyline: null,
      storeCoord: 'GCJ02'
    }
  },
  mounted() {
    this.communityId = getCommunityId()
  },
  beforeDestroy() {
    this.clearOverlays()
    this.map = null
  },
  methods: {
    loadData(route) {
      loadTianditu()
        .then(({ T, config }) => {
          this.storeCoord = config.STORE_COORD || 'GCJ02'
          this.initMap(T)
          this.loadRoute(route, T)
        })
        .catch(err => {
          this.$message && this.$message.error(err.message || '地图加载失败')
        })
    },
    initMap(T) {
      this.clearOverlays()
      const dom = document.getElementById('inspectionRouteMap')
      if (!dom) return
      this.map = new T.Map(dom)
      this.map.centerAndZoom(new T.LngLat(116.397128, 39.916527), 13)
      this.map.addControl(new T.Control.Zoom())
      this.map.addControl(new T.Control.Scale())
    },
    async loadRoute(route, T) {
      if (!route || !route.inspectionRouteId) return
      try {
        const response = await listInspectionRoutePoints({
          communityId: this.communityId,
          inspectionRouteId: route.inspectionRouteId,
          page: 1,
          row: 1000
        })
        this.routePoints = response.inspectionPoints || []
        this.addPointsToMap(this.routePoints, T)
      } catch (error) {
        console.error('获取路线点失败:', error)
        this.$message && this.$message.error(this.$t('inspectionRouteMap.fetchError'))
      }
    },
    addPointsToMap(points, T) {
      if (!this.map || !points || points.length === 0) return
      this.clearOverlays()

      const path = []
      points.forEach(point => {
        if (!point.lat || !point.lng) return
        const display = storeToTianditu(point.lng, point.lat, this.storeCoord)
        const lnglat = new T.LngLat(display.lng, display.lat)

        const icon = new T.Icon({
          iconUrl: '/img/maper.png',
          iconSize: new T.Point(25, 35),
          iconAnchor: new T.Point(12, 35)
        })
        const marker = new T.Marker(lnglat, { icon })
        this.map.addOverLay(marker)
        this.markers.push(marker)

        const label = new T.Label({
          text: point.inspectionName || '',
          position: lnglat,
          offset: new T.Point(-10, 18)
        })
        label.setBackgroundColor('rgba(255,255,255,0.0)')
        label.setBorderColor('rgba(255,255,255,0.0)')
        label.setFontColor('#3777FF')
        label.setFontSize(14)
        this.map.addOverLay(label)
        this.labels.push(label)

        path.push(lnglat)
      })

      if (path.length > 1) {
        this.polyline = new T.Polyline(path, {
          color: '#3777FF',
          weight: 5,
          opacity: 0.9
        })
        this.map.addOverLay(this.polyline)
      }

      if (path.length > 0) {
        this.map.centerAndZoom(path[0], 16)
      }
    },
    clearOverlays() {
      if (!this.map) {
        this.markers = []
        this.labels = []
        this.polyline = null
        return
      }
      this.markers.forEach(m => this.map.removeOverLay(m))
      this.labels.forEach(l => this.map.removeOverLay(l))
      if (this.polyline) {
        this.map.removeOverLay(this.polyline)
      }
      this.markers = []
      this.labels = []
      this.polyline = null
    }
  }
}
</script>

<style scoped>
.inspection-route-map-container {
  width: 100%;
  height: 100%;
}
</style>
